var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg04(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 487.688 487.688",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "430.312,200.272 430.312,209.892 478.125,215.104 478.125,225.881 430.312,221.549 430.312,231.15  478.125,235.482 478.125,249.213 430.312,245.34 430.312,254.932 478.125,258.814 478.125,272.996 487.688,273.77 487.688,206.536  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.438,124.585 229.5,109.237 229.5,142.228 296.438,153.751  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.625,213.583 401.625,145.374 336.695,131.833 336.877,205.121  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.438,163.447 229.5,151.934 229.5,232.718 296.438,238.197  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.973,243.734 401.625,249.797 401.625,223.222 336.906,214.76  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.75,254.156v-9.6v-14.277v-9.601V208.84v-9.62v-82.353l-219.938-58.8v192.561l219.938,17.738V254.156z M306,248.572 l-86.062-7.047V97.246L306,116.964V248.572z M411.188,260.297l-83.758-7.852l-0.335-132.374l84.093,17.538V260.297z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,292.121 191.25,247.664 191.25,59.943 0,165.532  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.375,412.254 382.5,410.207 382.5,307.678 363.375,307.057  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.062,307.984 392.062,409.184 420.722,406.125 420.367,308.912  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "459,401.916 468.562,400.846 468.562,310.471 459,310.164  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.683,415.965 353.812,413.277 353.812,306.742 328.118,305.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.951,304.57 289.82,420.115 319.12,416.979 318.556,305.604  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.062,303.021 239.062,425.537 280.277,421.127 277.37,304.264  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.284,405.102 437.676,404.316 449.438,402.998 449.438,309.85 429.93,309.219  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.065,260.898 200.812,260.229 200.812,260.402 200.812,265.211 200.812,429.619 229.5,426.559 229.5,293.135  478.125,301.225 478.125,399.994 487.688,398.971 487.688,283.361 427.214,278.484  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,301.932 0,305.547 0,403.857 191.25,429.477 191.25,265.709 191.25,259.828 191.25,257.475 93.846,280.119  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg04);
export default __webpack_public_path__ + "static/media/svg_04.f5977d32eab9f11583c5588d7c8ed033.svg";
export { ForwardRef as ReactComponent };